import jQuery from 'jquery';
import { secondary } from 'rp-navigation';
import moment from 'moment';
import 'moment-timezone';

export default class SecondaryNavigation {
    constructor() {
        this.date = moment().tz('Europe/London');
        this.selectedItem = jQuery('.js-RC-secondaryNavigation').attr('data-selected-item');

        const navigationItems = this.createNavigationItems();

        navigationItems.forEach(this.addItemToNavigation);
        this.setActiveNavigationItem(navigationItems);
        secondary.render();
    }

    addItemToNavigation({ title, url, urlPref }) {
        secondary.addItem(
            title,
            `/racecards/${url}`,
            undefined,
            { class: urlPref ? 'js-rc-list-url' : '' }
        );
    }

    createNavigationItems() {
        const navigationItems = [];
        const todayDate = this.date.clone().format('YYYY-MM-DD');

        navigationItems.push({ title: 'Today', url: '', label: todayDate, urlPref: true });
        navigationItems.push({ title: 'Tomorrow', url: 'tomorrow', label: 'Tomorrow', urlPref: true });

        [2, 3, 4, 5, 6].forEach((offset) => {
            const futureDate = this.date.clone().add(offset, 'days');
            const urlDate = futureDate.format('YYYY-MM-DD');
            const labelDate = futureDate.format('ddd D');

            navigationItems.push({ title: labelDate, url: urlDate, label: urlDate, urlPref: true });
        });

        navigationItems.push({ title: 'Big Race Entries', url: 'big-race-entries', label: 'Big Race Entries', urlPref: false });

        return navigationItems;
    }

    setActiveNavigationItem(navItems) {
        const selectedItem = navItems
            .find(({ label }) => (this.selectedItem === label));

        if (selectedItem) {
            secondary.setActiveItem(secondary.getItemByTitle(selectedItem.title));
        }
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/secondaryNavigation.js